<template>
  <div class="wrapper" id="chartPage">
    <div class="actBar" v-if="ifPrint">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" size="small" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      id="htmlToPdf"
      style="padding: 20px 25px 50px 25px"
      v-if="!pageRefresh"
    >
      <div
        v-for="item in chartNameList"
        :key="item"
        class="chartContainer"
        style="padding-top: 20px; height: 550px"
      >
        <div>
          <el-date-picker
            v-if="item == 'learnAnalysis'"
            v-model="searchCondition.learnDate"
            type="daterange"
            align="right"
            size="mini"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="
              (e) => {
                [searchCondition.learnStartDate, searchCondition.learnEndDate] =
                  e;
                timeLog();
              }
            "
          >
          </el-date-picker>
          <el-date-picker
            v-if="item == 'finishAnalysis'"
            v-model="searchCondition.finishDate"
            type="daterange"
            align="right"
            size="mini"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="
              (e) => {
                [
                  searchCondition.finishStartDate,
                  searchCondition.finishEndDate,
                ] = e;
                timeLog();
              }
            "
          >
          </el-date-picker>
        </div>
        <div
          style="width: 95%; display: block; height: 400px; margin: auto"
          :id="item"
        ></div>

        <!-- <div class="tips" style="font-size: 16px; width: 600px; margin: auto">
          {{ chartData[item].optionRemark }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { getLearnAnalysis } from "@/api/index.js";
export default {
  data() {
    return {
      searchCondition: {
        id: 0, //视频id
        learnStartDate: "", //学习趋势图搜索开始时间 （默认近7天）
        learnEndDate: "", //学习趋势图搜索结束时间
        finishStartDate: "", //完课率趋势图搜索开始时间
        finishEndDate: "", //完课率趋势图搜索结束时间
        learnDate: [],
        finishDate: [],
      },
      chartData: {},
      chartNameList: [],
      areaPrintReady: false,
      normalPrintReady: false,
      ifPrint: true,
      pageRefresh: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    timeLog() {
      console.log(this.searchCondition);
    },
    pageInit() {
      let now = new Date(),
        weekAgo = new Date(now.getTime() - 7 * 24 * 3600 * 1000);
      let nowString = `${now.getFullYear()}-${
          now.getMonth() + 1
        }-${now.getDate()}`,
        weekAgoString = `${weekAgo.getFullYear()}-${
          weekAgo.getMonth() + 1
        }-${weekAgo.getDate()}`;
      Object.assign(this.searchCondition, {
        learnStartDate: weekAgoString,
        learnEndDate: nowString,
        learnDate: [weekAgoString, nowString],
        finishStartDate: weekAgoString,
        finishEndDate: nowString,
        finishDate: [weekAgoString, nowString],
        id: this.$route.query.id,
      });
    },

    getData() {
      console.log(typeof this.$route.query.id);
      this.pageRefresh = true;
      setTimeout(() => {
        this.pageRefresh = false;
      }, 500);

      getLearnAnalysis(this.searchCondition).then((data) => {
        this.chartNameList = [];
        for (let i in data.data) {
          // 只有用于制作图标的数据是字符串
          if (typeof data.data[i] == "string") {
            this.chartNameList.push(i);
            let dataParse = JSON.parse(data.data[i]);
            dataParse.color = [
              "#7EC0EE",
              "#FF9F7F",
              "#FFD700",
              "#C9C9C9",
              "#E066FF",
              "#C0FF3E",
            ];
            this.chartData[i] = dataParse;
            console.log(this.chartData[i]);
          }
        }
        setTimeout(() => {
          this.chartInit();
        }, 1000);
      });
    },
    chartInit() {
      this.chartNameList.forEach((item) => {
        if (Array.isArray(this.chartData[item])) {
        } else {
          let chart = echarts.init(document.getElementById(item));

          chart.setOption(this.chartData[item]);
        }
      });
      this.normalPrintReady = true;
    },
  },
  mounted() {
    this.pageInit();

    this.getData();
  },
};
</script>

<style scoped lang="less"  media="print">
.wrapper {
  padding-top: 30px;
  width: 810px;
  margin: auto;
  .chartContainer {
    margin-bottom: 30px;
  }
  .areaChartListContainer {
    .areaCell {
      margin: 20px auto;
    }
  }
}
</style>
